import React, { Component } from 'react';
// import $ from 'jquery';
// import ReactDOM from 'react-dom';
import axios from 'axios';
// import Middleware from '../middle-ware/Middleware';
import { fetchData, getCartProducts, getProducts, get_user_lang } from '../../../repository';
// import Basketmenuitems from '../basket-menu-items/Basketmenuitems';
import Cartbasketitems from './Cartbasketitems';
import Dropdownmenu from '../../../components/dropdown-menu/Dropdownmenu';

let iPad = 768; 
let iPadpro = 1024;
let popoverWidth = '';
let BASE_URL = '';
let cart_url;
let checkout_url;
let userlang = '';
if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    BASE_URL = 'http://localhost:8001';
}else if (window.location.hostname === 'dev.cocoonsealy.net/'){
    BASE_URL = 'http://dev.cocoonsealy.net';
}else if (window.location.hostname === 'staging.cocoonbysealy.ca'){
    BASE_URL = 'https://staging.cocoonbysealy.ca';
}else{
    BASE_URL = 'https://cocoonbysealy.ca';
}

class Cartbasket extends Component {    
     
    
    constructor(props) {
        super(props);
        this.child = React.createRef();
        this.state = {            
            isShow: false,             
            cartModal: 'basket-popover basket-popover__close',                      
            divStyle: {    
                top: '137px', 
                right: getSizex(), 
                border: 'medium none', 
                boxShadow: 'none',            
            },
            trigger: '',
            parent_products: [],
            child_products_urls: [],
            child_products_urls_set: false,
            basket_products: [],
            products_set: false,
            product: [],
            current_product_title: '',

            products: [],
            products_detail:[],
            temp_products_detail:[],
            parent_category: '',            
            parent_products: [],            
            parent_products_meta_data: [],
            children_products: [],
            children_products_detail: [],
            product_price: [],
            product_sku: [],
            product_availability: [],
            product_options: [],

            modalStyle: {    
                position: 'absolute', 
                inset: '0px', 
                backgroundColor: 'rgba(255, 255, 255, 0)', 
                // border: '1px solid red',
                display: 'none'
            },
            num_of_products: 0,
            basket:[],
            basket_lines:[],  
            minibasket_set: false,
            basketItems: [],
            userlang: ''

        };       
                
        // console.log("Cart Basket Constructor");
        // console.log(props); 
    }    
    
    componentDidUpdate (prevState) {
        // if ( this.state.basket !== this.prevState.basket){
        //     console.log(`Getting Cart Basket Products ////////////////////////////////////////////////`);
            
        // }
    }    

    componentDidMount() {
        
        // product_url = document.getElementsByClassName('hero hero--chill')[0].dataset.productUrl;
        cart_url = document.getElementsByClassName('basket-summary')[0].getAttribute('href');
        checkout_url = document.getElementsByClassName('checkout-index')[0].getAttribute('href');
        const set_lang = window.document.getElementsByClassName("user-lang")[0];                                                  
                        
        window.addEventListener("load", this.updateDivStyle);
        window.addEventListener("resize", this.updateDivStyle);        

        const CartTarget = window.document.getElementById('basket-items');                 

        this.get_cbs_language_cookie();
        this.init_m();
        
        CartTarget.addEventListener("click", this.toggleShow);                        
        // CartDiv.addEventListener("click", this.toggleShow);

        CartTarget.onclick = function(event) {
            //event.preventDefault();            
            //console.log('ONCLICK');                        
        };
        
        if (window.location.pathname !== '/en/store/checkout/thank-you/' && window.location.pathname !== '/fr/store/checkout/thank-you/') {
            
            this.get_cart_basket();   

            // getProducts()
            
            // .then((parent_products) => {
            //     // console.log(`parent products`, parent_products)
            //     this.setState({ 
            //         parent_products: parent_products 
            //     })
                
            // })   
        }                     
        
    }

    init_m = () => {
        const data = 1;    
        this.setState({
            trigger: data
        }, () => {
            
        });    
    }


    get_cbs_language_cookie = () => {
        get_user_lang().then( (data) => {
            // console.log('User language is ... ',data);
            if (data.userlang !== undefined) {
                userlang = data.userlang;
                this.setState({
                    userlang
                });
            }
        })  
    }

    set_user_language = (e) => {
        e.preventDefault();
        // console.log('Now Send form');
        const form = window.document.getElementById('userlang');
        form.submit();        
    }

    match_mattress_size = (data) => {
        let title;
        if (window.location.pathname === '/en/store/basket/' || window.location.pathname === '/fr/store/basket/') {
            title = window.Basket.get_product_title(data)
        }else{
            // fetchData(data)
            // .then( (data) => {
            //     // console.log(`mattress size working data test`, data);
            //     this.setState({
            //         current_product_title: data.title
            //     })
            // })
            // console.log(`mattress size working data`, this.state.current_product_title);
            // title = this.state.current_product_title;
            title = data;
        }
        let mattress_size = "";        

        if (title.match(/King/g)) {
            // alert("FUCK YEAH Title: " + childProducts.title + " ID" + childProducts.id);
            mattress_size = "King";                    
        }else if (title.match(/Queen/g)) {
            // alert("FUCK YEAH Title: " + childProducts.title + " ID" + childProducts.id);
            mattress_size = "Queen";
        }else if (title.match(/Full/g)) {
            // alert("FUCK YEAH Title: " + childProducts.title + " ID" + childProducts.id);
            mattress_size = "Full";
        }else if (title.match(/Twin/g) && !title.match(/XL/g)) {
            // alert("FUCK YEAH Title: " + childProducts.title + " ID" + childProducts.id);
            mattress_size = "Twin";
        }else if (title.match(/XL/g) && title.match(/Twin/g)) {
            // alert("FUCK YEAH Title: " + childProducts.title + " ID" + childProducts.id);
            mattress_size = "Twin XL";
        }
        return mattress_size;
        
    }

    set_current_product_title = (title) => {
        this.setState({
            current_product_title: title
        })
    }

    get_product_title = (url) => {
        // console.log(`+++++++++++==================+===++==+++++++++++++++ MiniBasket Product Url ++========++++++++=+======+===`, url);
        // console.log(`+++++++++++==================+===++==+++++++++++++++ MiniBasket ++========++++++++=+======+===`, this.state);

        let title = '';
        let product = this.state.products;    
        let child_products = this.state.children_products_detail;
        // console.log(`+++++++++++==================+===++==+++++++++++++++ MiniBasket Products ++========++++++++=+======+===`, this.state.products);
        // console.log(`+++++++++++==================+===++==+++++++++++++++ MiniBasket Child Products ++========++++++++=+======+===`, child_products);
        if (window.location.pathname === '/en/store/basket/' || window.location.pathname === '/fr/store/basket/') {
            // title = window.Basket.get_product_title(url)
            // console.log(`+++++++++++==================+===++==+++++++++++++++ MiniBasket Products ++========++++++++=+======+===`, this.state.products);
            product = product.filter(item => item.url === url);
            // console.log(`+++++++++++==================+===++==+++++++++++++++ MiniBasket Product ++========++++++++=+======+===`, product);
            title = product[0].title;
        }else{                            
            // console.log(`+++++++++++==================+===++==+++++++++++++++ MiniBasket Products ++========++++++++=+======+===`, this.state.products);
            product = product.filter(item => item.url === url);

            if (product === undefined) {
                product = child_products.filter(item => item.url === url);
            }

            // console.log(`+++++++++++==================+===++==+++++++++++++++ MiniBasket Product ++========++++++++=+======+===`, product);
            
            title = product[0].title;
        }
        // console.log(`+++++++++++==================+===++==+++++++++++++++ MiniBasket Product Title ++========++++++++=+======+===`, title);
        return title;
    }

    get_product_url = (data) => {
        let product_url;
        let title;

        if (window.location.pathname === '/en/store/basket/' || window.location.pathname === '/fr/store/basket/') {
            // title = window.Basket.get_product_title(data)
            title = data;
        }else{
            title = data;
        }        

        if (title.match(/Cocoon Classic/g)) {
            product_url = '/mattress/classic/purchase/';
        } else if (title.match(/Essential Medium/g)) { 
            product_url = '/mattress/essential/purchase/';
        } else if (title.match(/Sealy Premium/g)) {
            product_url = '/pillows/premium-pillow/';
        } else if (title.match(/Sealy Performance/g)) {
            product_url = '/pillows/performance-pillow/';
        } else if (title.match(/Sealy Essential/g)) {
            product_url = '/pillows/essentials-pillow/';
        }

        return product_url;
    }

    get_product_category = (data) => {
        let product_category;
        let title;

        if (window.location.pathname === '/en/store/basket/' || window.location.pathname === '/fr/store/basket/') {
            // title = window.Basket.get_product_title(data)
            title = data;
        }else{
            title = data;
        }        

        if (title.match(/Cocoon Classic/g)) {
            product_category = 'cocoon-classic';
        } else if (title.match(/Cocoon Essential/g)) { 
            product_category = 'cocoon-essential';
        } else if (title.match(/Sealy Premium/g)) {
            product_category = 'sealy-premium';
        } else if (title.match(/Sealy Performance/g)) {
            product_category = 'sealy-performance';
        } else if (title.match(/Sealy Essential/g)) {
            product_category = 'sealy-essential';
        }

        return product_category;
    }
 
    updateDivStyle = () => {          
           
        this.setState({
            divStyle: {    
                top: '137px', 
                right: getSizex(), 
                border: 'medium none', 
                boxShadow: 'none'
            },
            
        });
    }    

    closeModal = (e) => {           
        // console.log("Class: " + e.target.parentNode.className)   
        // console.log("ID: " + e.target.id)
        
            if (this.state.isShow === true && e.target.parentNode.className != 'ReactModalPortal' ){
                
                // console.log("Closing Modal");  
                this.setState(state => ({
                    cartModal: 'basket-popover basket-popover__close',
                    isShow: false,
                    modalStyle: {    
                        position: 'absolute', 
                        inset: '0px', 
                        backgroundColor: 'rgba(255, 255, 255, 0)', 
                        // border: '1px solid red',
                        display: 'none'
                    },
                }));
            }
                  
    }

    toggleShow = (_State) => {        
        // console.log('toggle')
        
        // console.log(this.state)
        // console.log(this.props)
        if (this.state.num_of_products > 0) {
            if (this.state.isShow == true) {
                // console.log(`close`)
                this.setState(state => ({                
                    cartModal: 'basket-popover basket-popover__close',
                    modalStyle: {    
                        position: 'absolute', 
                        inset: '0px', 
                        backgroundColor: 'rgba(255, 255, 255, 0)', 
                        // border: '1px solid red',
                        display: 'none'
                    },
                }));
                
            }else {
                // console.log(`open`)
                this.setState(state => ({                
                    cartModal: 'basket-popover',
                    modalStyle: {    
                        position: 'absolute', 
                        inset: '0px', 
                        backgroundColor: 'rgba(255, 255, 255, 0)', 
                        // border: '1px solid red',
                        display: 'block'
                    },
                }));
            }
    
            this.setState(
                {
                    isShow: !this.state.isShow,
                
                }            
            );
        }
        
    };

    get_cart_basket = () => { 
        // const pdata="hello"         
        // window.maincart.update_cart_basket(pdata);   
        
        getCartProducts().then( (data) => {
            this.setState({
                basket:data
            })

            return data
        })
        .then( (data) => {
            // console.log(`---------------------------- getting cart Basket ----------------------------------`, data)                        
            this.get_basket_lines(data.lines);                  
        })
    }
    
    get_basket_lines = (url) => {  
        // console.log(`+++++++++++==================+===++==++ MiniBasket Basket Basket Lines ++========++++++++=+======+===`, url); 
        // console.log(`+++++++++++==================+===++==+++++++++++++++ MiniBasket Basket ++========++++++++=+======+===`, this.state.basket);                     
        let products = []        
        fetchData(url).then( (res) => {
            let items = 0;
            for (let [key, pvalue] of Object.entries(res)) {     
                items = items + pvalue.quantity;
            }
            this.setState({ 
                num_of_products: items,
                basket_lines: res,
                minibasket_set: false
            });

          return res
        })

        .then( (data) => {
            // Fetch all product information and set to state                         
            let products_data = [];
            let new_products;
            let current_products;
            let i=0;
            // console.log(`+++++++++++==================+===++==++ MiniBasket Basket fetched Product Data ++========++++++++=+======+===`, data);
            for ( let [key, value] of Object.entries(data) ){            
                // console.log(`${key}: ${value.product}`);
                
                fetchData(value.product).then( (res) => {
                    // console.log(`+++++++++++==================+===++==++ MiniBasket Basket fetched Data ++========++++++++=+======+===`, res);
                    // products_data = products.concat(res);
                    return res;
                })
                
                .then( (products_data) => {
                    // console.log(`+++++++++++==================+===++==++ MiniBasket Basket Incoming Data 1 ++========++++++++=+======+===`, products_data);
                    // console.log(`+++++++++++==================+===++==++ MiniBasket Basket New Products Data State ${key} ++========++++++++=+======+===`, this.state.basket_products);
                    current_products = this.state.basket_products;
                    new_products = current_products.concat(products_data);
                    this.setState({
                        basket_products: new_products
                    }, () => {
                        // console.log(`+++++++++++==================+===++==++ MiniBasket Basket New Products Data State ${key} ++========++++++++=+======+===`, this.state.products);
                    })
                }) 

            }                        
        })

        // .then( () => {
        //     if(this.state.products.length > 0)
        //         console.log(`+++++++++++==================+===++==++ MiniBasket Basket New Products Data State Final ++========++++++++=+======+===`, this.state.products);
        // })
        
    }

    update_basket = () => {
        // console.log(`updating mini basket 1`);        
        this.get_cart_basket();
        // this.child.current.update_basket();        
    }

    get_product_info = (data) =>{
        
        
                    
    }
    

    match_mattress_comfort = (title) => {
        let comfort = "";
        if (title.match(/Soft/g)) {
            // alert("FUCK YEAH Soft Title: " + childProducts.title + " ID" + childProducts.id);
            comfort = "Soft";
        }else if (title.match(/Firm/g)) {
            // alert("FUCK YEAH Firm Title: " + childProducts.title + " ID" + childProducts.id);
            comfort = "Firm";
        }else if (title.match(/Medium/g)) {
            // alert("FUCK YEAH Medium Title: " + childProducts.title + " ID" + childProducts.id);
            comfort = "Medium";
        }

        return comfort;
        
    }

    get_child_products = () => {

        let products = [];
        if (this.state.parent_products.length > 0) {
            // console.log(`MInibasket state`, this.state);     
            this.getChildProductUrls();                            
        }         

        if (this.state.child_products_urls_set === true && this.state.products_set === false) {
            let results = [];        
            const urls = this.state.child_products_urls;        

            for (let [key, pvalue] of Object.entries(urls)) {            
                results[key] = fetchData( pvalue.url )            
            }

            axios.all(results)
                .then(axios.spread(function (results_1, results_2, results_3, results_4, results_5, results_6, results_7, results_8, results_9, results_10, results_11, results_12, results_13, results_14, results_15) {                
                    // console.log(`Processing Child Products`);                
                    products = products.concat(results_1);                
                    products = products.concat(results_2);
                    products = products.concat(results_3);
                    products = products.concat(results_4);
                    products = products.concat(results_5);
                    products = products.concat(results_6);
                    products = products.concat(results_7);
                    products = products.concat(results_8);
                    products = products.concat(results_9);
                    products = products.concat(results_10);
                    products = products.concat(results_11);
                    products = products.concat(results_12);
                    products = products.concat(results_13);
                    products = products.concat(results_14);
                    products = products.concat(results_15);
                    
                    return products;
                
                }))

                .then( (data) => {
                    // console.log(`products`, data);
                    
                    this.setState({
                        products: data,
                        products_set: true
                    });
                })
            
        }
    }

    getChildProductUrls = () => {        
        const urls = this.state.parent_products;                          
        let results = [];
        let childUrls = [];       
        
        

        if (this.state.child_products_urls_set === false) {
            for (let [key, pvalue] of Object.entries(urls)) {            
                results[key] = fetchData( pvalue.url )            
            }        
    
            axios.all(results)
                .then(axios.spread(function (resultsA, resultsB) {
                    // Both requests are now complete
                    // console.log(`Processing Child Urls`);                
                    // console.log(resultsA);                
                    // console.log(resultsB);
                    
                    let item_categoryB;
                    let item_categoryA;
    
                    if (resultsA.title === 'Essential Medium') {
                        item_categoryA = 'cocoon-essential';
                    } 
    
                    if (resultsB.title === 'Cocoon Classic') {
                        item_categoryB = 'cocoon-classic';
                    }
    
                    for (let [key, value] of Object.entries(resultsA.children)) {                    
                        // console.log(`${key}: ${value}`);                    
                        childUrls = childUrls.concat({'url':value.url, 'parent_id':resultsA.id, 'category':item_categoryA});                    
                    }
    
                    for (let [key, value] of Object.entries(resultsB.children)) {                    
                        // console.log(`${key}: ${value}`);                    
                        childUrls = childUrls.concat({'url':value.url, 'parent_id':resultsB.id, 'category':item_categoryB});                                                            
                    }                
                    
                    // return childUrls;                
                                    
                }))
    
                .then( (data) =>{                
                    this.setState({
                        child_products_urls: childUrls,
                        child_products_urls_set: true
                    });
                }) 
        }
                
                
    }

    set_minibasket = () => {
        this.setState({
            minibasket_set: true
        });
    }

    set_basketItems = (basketItems) => {

        this.setState({
            basketItems: this.state.basketItems.concat(basketItems) 
        })
    }    

    /* // initializing product data */

    init_products_details_temp = (products_detail) => {
        // console.log(`Sent in products detail`, products_detail);
        this.setState({
            temp_products_detail: this.state.temp_products_detail.concat(products_detail)
        });                
    }

    init_products_details = (products_detail) => {
        // console.log(`Minibasket Finalizing products detail`, products_detail);        
        this.setState({
            products_detail
        });
    }

    init_products = (products) =>{        
        this.setState({
            products
        });
    }

    init_product_meta = (metadata) => {        
        // console.log(`Minibasket product metadata`, metadata);        
        this.setState({
            parent_products_meta_data: metadata
        });
    }

    set_product_sku = (product_sku, product_id) => {
        const data = {sku: product_sku, id: product_id}
        this.setState({
            product_sku: this.state.product_sku.concat(data)
        });
    };

    set_product_price = (product_price, product_id) => {
        // console.log(`Product Price: `, product_price);
        const data = {price: product_price, id: product_id}
        this.setState({
            product_price: this.state.product_price.concat(data)
        });
    };

    set_product_availability = (product_availability, product_id) => {
        const data = {availability: product_availability, id: product_id}
        this.setState({
            product_availability: this.state.product_availability.concat(data)
        });
    };      
    
    set_child_products = (children_products) => {
        // console.log(`Current Children Products ${this.state.children_products.length}`, this.state.children_products);
        this.setState({
            children_products: this.state.children_products.concat(children_products)
        });
    }

    set_child_products_detail = (children_products_detail) => {
        this.setState({
            children_products_detail: this.state.children_products_detail.concat(children_products_detail),
            products_set: true
        });
    }    

    set_product_options = (options) => {
        this.setState({
            product_options: this.state.product_options.concat(options)
        });        
    }

    

    render(){  
        // const parent_products = this.state.parent_products;    
        // const child_products_urls = this.getChildProductUrls();            
        // const child_products_urls_set=this.state.child_products_urls_set;
        
        return(            
            <React.Fragment>
                <Cartbasketitems 
                    ref={this.child}
                    basket={this.state.basket}
                    basket_lines={this.state.basket_lines}
                    match_mattress_comfort={this.match_mattress_comfort}
                    match_mattress_size={this.match_mattress_size}
                    get_product_title={this.get_product_title}                
                    get_product_url={this.get_product_url}
                    isShow={this.state.isShow}
                    cartModal={this.state.cartModal}
                    divStyle={this.state.divStyle}
                    modalStyle={this.state.modalStyle}
                    trigger={this.state.trigger}             
                    num_of_products={this.state.num_of_products}
                    get_product_category={this.get_product_category}                
                    set_current_product_title={this.set_current_product_title}
                    current_product_title={this.state.current_product_title}
                    closeModal={this.closeModal}
                    get_child_products={this.get_child_products}
                    parent_products={this.state.parent_products}
                    // child_products_urls_set={child_products_urls_set}
                    basket_products={this.state.basket_products}      
                    products_set={this.state.products_set}                
                    minibasket_set={this.state.minibasket_set}
                    set_minibasket={this.set_minibasket}
                    set_basketItems={this.set_basketItems}
                    basketItems={this.state.basketItems}
                    userlang={this.state.userlang}

                    init_products={this.init_products}
                    products={this.state.products}           
                    product_options={this.state.product_options}        
                    init_products_details_temp={this.init_products_details_temp}  
                    products_detail_temp={this.state.temp_products_detail}
                    init_products_details={this.init_products_details}
                    products_detail={this.state.products_detail}
                    children_products_detail={this.state.children_products_detail}
                    children_products={this.state.children_products}
                    init_product_meta={this.init_product_meta}
                    set_child_products={this.set_child_products}
                    set_child_products_detail={this.set_child_products_detail}                    
                    set_product_options={this.set_product_options}
                    set_product_sku={this.set_product_sku}
                    set_product_availability={this.set_product_availability}
                    set_product_price={this.set_product_price}                    
                    parent_products_meta_data={this.state.parent_products_meta_data}                                 
                />
                {
                    window.location.pathname === '/en/store/basket/' || window.location.pathname === '/fr/store/basket/' 
                    || window.location.pathname === '/en/mattress/essential/purchase/' || window.location.pathname === '/fr/mattress/essential/purchase/' || 
                    window.location.pathname === '/en/mattress/classic/purchase/' || window.location.pathname === '/fr/mattress/classic/purchase/'?
                    <Dropdownmenu />:''                                    
                }
                
            </React.Fragment>            
        )
    } 
    
    componentWillUnmount() {
        window.removeEventListener("load", this.updateDivStyle);
        window.removeEventListener("resize", this.updateDivStyle);        
        const CartTarget = window.document.getElementById('basket-items');
        CartTarget.removeEventListener("click", this.toggleShow);         
    }
      
};


function svgCloseicon (props) {
    return (
        <svg 
            version="1.1" 
            id="Layer_1" 
            xmlns="http://www.w3.org/2000/svg" 
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x="0px" 
            y="0px" 
            viewBox="52.9 54.2 43 43.6" 
            enableBackground="new 52.9 54.2 43 43.6" 
            xmlSpace="preserve"
            className="pdp-modal__close-icon"
        >
            <g>
                <g>
                    <path fill="#999999" d="M54.3,97.4c-0.2,0-0.7,0-1-0.2c-0.5-0.5-0.5-1.2,0-1.8l40.5-40.5c0.5-0.5,1.2-0.5,1.8,0
            c0.5,0.5,0.5,1.2,0,1.8L55,97.1C54.8,97.4,54.5,97.4,54.3,97.4z"></path>
                </g>
            </g>
            <g>
                <g>
                    <path fill="#999999" d="M94.8,97.4c-0.2,0-0.8,0-1-0.2L53.2,56.6c-0.5-0.5-0.5-1.2,0-1.8c0.5-0.5,1.2-0.5,1.8,0l40.5,40.5
            c0.5,0.5,0.5,1.2,0,1.8C95.5,97.4,95,97.4,94.8,97.4z"></path>
                </g>
            </g>
        </svg>
    )
}

function getSizex() {
        
    const screenSize = window.document.documentElement.clientWidth;  
    const XscreenSize = window.document.documentElement.screenSize; 
    // console.log(`screenSize: ${XscreenSize} screenWidth: ${screenSize}`);
    if (screenSize > iPad && screenSize < iPadpro) {
        popoverWidth = 200
    }else if (screenSize > iPadpro && screenSize <= 1300) {
        popoverWidth = 300
    }else if (screenSize > 1300 && screenSize <= 1350) {
        popoverWidth = 325
    }else if (screenSize > 1350 && screenSize <= 1400) {
        popoverWidth = 350
    }else if (screenSize > 1400 && screenSize <= 1450) {
        popoverWidth = 375
    }else if (screenSize > 1450 && screenSize <= 1500) {
        popoverWidth = 400
    }else if (screenSize > 1500 && screenSize <= 1550) {
        popoverWidth = 425
    }else if (screenSize > 1550 && screenSize <= 1600) {
        popoverWidth = 450
    }else if (screenSize > 1650 && screenSize <= 1700) {
        popoverWidth = 475
    }else if (screenSize > 1750 && screenSize <= 1800) {
        popoverWidth = 500
    }else if (screenSize > 1850 && screenSize <= 1900) {
        popoverWidth = 525
    }else if (screenSize == iPad) {
        popoverWidth = 60
    }else if (screenSize == iPadpro) {
        popoverWidth = 160
    } else {
        popoverWidth = 669.5
    }
    // console.log(`cart position: ${popoverWidth} `);

    return (
        popoverWidth
    )
    
}



export default Cartbasket;